import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { LoadingSpinner } from '../../../components/common';

const ReturnLabelSuccessPage = () => {
  const history = useHistory();
  const location = useLocation();
  const labelData = location.state?.labelData;

  if (!labelData) {
    return (
      <div className="flex flex-col items-center justify-center p-6">
        <LoadingSpinner size="lg" />
        <p className="mt-4">Loading return label data...</p>
      </div>
    );
  }

  const { labelUrl, trackingNumber, trackingUrl } = labelData;

  return (
    <div className="max-w-3xl mx-auto p-6">
      <div className="bg-green-50 border-l-4 border-green-500 p-4 mb-6">
        <div className="flex">
          <div className="flex-shrink-0">
            <svg className="h-5 w-5 text-green-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
            </svg>
          </div>
          <div className="ml-3">
            <p className="text-sm leading-5 font-medium text-green-800">
              Return shipping label has been successfully generated!
            </p>
          </div>
        </div>
      </div>

      <h1 className="text-2xl font-semibold mb-6">Return Label Created</h1>

      <div className="bg-white p-6 rounded-lg shadow-sm mb-6 border border-gray-200">
        <h2 className="text-lg font-medium mb-4">Shipping Information</h2>
        <div className="mb-4">
          <p><span className="font-medium">Tracking Number:</span> {trackingNumber}</p>
          {trackingUrl && (
            <p className="mt-1">
              <a 
                href={trackingUrl} 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-brand-teal hover:text-brand-teal-dark"
              >
                Track your shipment
              </a>
            </p>
          )}
        </div>

        <div className="mb-6">
          <a
            href={labelData.label_url}
            download
            className="inline-block bg-brand-teal-light-hover text-white px-4 py-2 rounded hover:bg-brand-teal-dark"
          >
            Download Return Label
          </a>
        </div>

        <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4">
          <div className="flex">
            <div className="flex-shrink-0">
              <svg className="h-5 w-5 text-yellow-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
              </svg>
            </div>
            <div className="ml-3">
              <p className="text-sm leading-5 text-yellow-700">
                Please print this label and attach it to your package. The label must be clearly visible on the outside of the package.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-white p-6 rounded-lg shadow-sm mb-6 border border-gray-200">
        <h2 className="text-lg font-medium mb-4">Next Steps</h2>
        <ol className="list-decimal list-inside space-y-2">
          <li>Print the return shipping label</li>
          <li>Package the item securely in its original packaging if possible</li>
          <li>Attach the return label to the outside of the package</li>
          <li>Drop off the package at the carrier's nearest location</li>
          <li>Keep the tracking number for your records</li>
        </ol>
      </div>

      <div className="flex justify-between">
        <button 
          onClick={() => history.push('/dashboard/returns')}
          className="px-4 py-2 bg-gray-200 rounded hover:bg-gray-300"
        >
          Back to Returns
        </button>
        <button 
          onClick={() => history.push('/dashboard')}
          className="px-4 py-2 bg-brand-teal text-white rounded hover:bg-brand-teal-dark"
        >
          Go to Dashboard
        </button>
      </div>
    </div>
  );
};

export default ReturnLabelSuccessPage; 